export default __webpack_public_path__ + "static/media/left-top-vinho2.e5c0ad4e.png";